// Daily puzzle helpers shared by the puzzle page, the archive and the lobby
// card. The server side is backend/daily.py.

export const MAX_TRIES = 3;

// "Mon 13 Oct" from "2026-10-13" (a UTC date: the puzzle's day).
export function dayLabel(iso, opts = { weekday: "short", day: "numeric", month: "short" }) {
  const d = new Date(`${iso}T12:00:00Z`);
  return d.toLocaleDateString("en-GB", { ...opts, timeZone: "UTC" });
}

export const starText = (n) => "★".repeat(n || 0) + "☆".repeat(3 - (n || 0));

// Each puzzle is rated 1 to 3 stars for how hard it is (backend/daily.py).
export const DIFFICULTY = { 1: "Easy", 2: "Medium", 3: "Hard" };
export const difficultyLabel = (n) => `${starText(n)} ${DIFFICULTY[n] || ""}`.trim();

// The result to paste into a chat, Wordle style: a square per try.
export function shareText(d) {
  const tries = d.tries || 0;
  const squares = Array.from({ length: MAX_TRIES }, (_, k) =>
    k < tries - (d.won ? 1 : 0) ? "🟥" : k === tries - 1 && d.won ? "🟩" : "⬜"
  ).join("");
  const line = d.won ? `${d.tiles} tile${d.tiles === 1 ? "" : "s"} (par ${d.par})` : "Not solved";
  return `Jangle Daily #${d.n} ${starText(d.difficulty)}\n${squares} ${line}\nplayjangle.com/daily`;
}

export async function share(text) {
  try {
    if (navigator.share) {
      await navigator.share({ text });
      return "shared";
    }
  } catch {
    /* cancelled: fall back to copying */
  }
  try {
    await navigator.clipboard.writeText(text);
    return "copied";
  } catch {
    return null;
  }
}
